import { BaseContainerModel } from '../../base-container.model';
import { bl_crm_membership_card_type_hdr_RowClass } from '../../../dbschema';

export class MembershipCardTypeContainerModel extends BaseContainerModel {
    bl_crm_membership_card_type_hdr: bl_crm_membership_card_type_hdr_RowClass = new bl_crm_membership_card_type_hdr_RowClass();
}
